export default __webpack_public_path__ + "static/media/graph-2.118e76b1.png";